import script from "./UsuarioPerfilEditPage.vue?vue&type=script&setup=true&lang=js"
export * from "./UsuarioPerfilEditPage.vue?vue&type=script&setup=true&lang=js"

import "./UsuarioPerfilEditPage.vue?vue&type=style&index=0&id=74e77c2d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74e77c2d"]])

export default __exports__